import "./PortalLogoutConfirm.css";

let activePromise = null;

/**
 * Modern logout confirm (replaces window.confirm) for HQ / head portals.
 * @returns {Promise<boolean>}
 */
export function confirmPortalLogout({
  title = "Confirm logout",
  description = "You will need to sign in again to continue.",
  confirmLabel = "Log out",
  cancelLabel = "Cancel",
} = {}) {
  if (typeof document === "undefined") {
    return Promise.resolve(false);
  }
  if (activePromise) {
    return activePromise;
  }

  activePromise = new Promise((resolve) => {
    const overlay = document.createElement("div");
    overlay.className = "portal-logout-modal-overlay";
    overlay.setAttribute("role", "presentation");

    const panel = document.createElement("div");
    panel.className = "portal-logout-modal";
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-modal", "true");
    panel.setAttribute("aria-labelledby", "portal-logout-title");

    const finish = (result) => {
      document.removeEventListener("keydown", onKeyDown);
      overlay.remove();
      activePromise = null;
      resolve(result);
    };

    const onKeyDown = (event) => {
      if (event.key === "Escape") {
        event.preventDefault();
        finish(false);
      }
    };

    panel.innerHTML = `
      <div class="portal-logout-modal-icon" aria-hidden="true">⎋</div>
      <h2 id="portal-logout-title" class="portal-logout-modal-title"></h2>
      <p class="portal-logout-modal-description"></p>
      <div class="portal-logout-modal-actions">
        <button type="button" class="portal-logout-modal-button portal-logout-modal-button-secondary" data-action="cancel"></button>
        <button type="button" class="portal-logout-modal-button portal-logout-modal-button-primary" data-action="confirm"></button>
      </div>
    `;

    panel.querySelector(".portal-logout-modal-title").textContent = title;
    panel.querySelector(".portal-logout-modal-description").textContent = description;
    panel.querySelector('[data-action="cancel"]').textContent = cancelLabel;
    panel.querySelector('[data-action="confirm"]').textContent = confirmLabel;

    panel.querySelector('[data-action="cancel"]').addEventListener("click", () => finish(false));
    panel.querySelector('[data-action="confirm"]').addEventListener("click", () => finish(true));
    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) finish(false);
    });

    overlay.appendChild(panel);
    document.body.appendChild(overlay);
    document.addEventListener("keydown", onKeyDown);
    panel.querySelector('[data-action="confirm"]').focus();
  });

  return activePromise;
}
